<h2 id="my-toil-request-dialog-title" mat-dialog-title tabindex="-1" cdkFocusInitial>
    {{ 'ToilRequest' | translate: {Default: "Time Off In Lieu Request"} }}
</h2>

<mat-dialog-content aria-labelledby="my-toil-request-dialog-title" aria-describedby="my-toil-request-dialog-description">
    <p id="my-toil-request-dialog-description" class="sr-only">
        Request details including status, approvers, dates, duration, and comments.
    </p>
    <div class="top">
        
        <div
            class="status"
            role="group"
            [attr.aria-label]="'Request status details. Status: ' + (employeeToilRequest.requestStatus?.name || 'Unknown')"
        >
            <span class="label">{{ 'Status' | translate: {Default: "Status"} }}:</span>

                <mat-chip 
                [ngClass]="{
                    'red-chip': employeeToilRequest.requestStatus?.id === 'trs_Denied',
                    'green-chip': employeeToilRequest.requestStatus?.id === 'trs_Approved',
                    'orange-chip': employeeToilRequest.requestStatus?.id === 'trs_Pending'
                }"
                >{{ employeeToilRequest.requestStatus?.name }}</mat-chip>
            
            <div class="requested-on">
                <span class="label">{{ 'RequestedOn' | translate: {Default: "Requested On"} }}:</span> {{ moment(employeeToilRequest.createdOn).format('lll') }}
            </div>

            <div class="status-updated-by" *ngIf="employeeToilRequest.requestStatusSetBy !== null">
                <span class="label">{{ 'RequestStatusSetBy' | translate: {Default: "Request Status Set By"} }}:</span>
                
                <div class="employee-name">
                    <app-employee-image [profilePhoto]="employeeToilRequest.requestStatusSetBy?.profilePhoto" [width]="35" [height]="35" [round]="true" *ngIf="!isLoading"></app-employee-image>

                    <span class="employee">
                        {{employeeToilRequest.requestStatusSetBy?.firstName}} {{employeeToilRequest.requestStatusSetBy?.lastName}}
                    </span>
                </div>
            </div>

            <div class="status-date" *ngIf="employeeToilRequest.requestStatusUpdatedOn !== null">
                <span class="label">{{ 'RequestStatusUpdatedOn' | translate: {Default: "Request Status Updated On"} }}:</span>

                {{ moment(employeeToilRequest.requestStatusUpdatedOn).format('lll') }}
            </div>

            <div class="status-date" *ngIf="employeeToilRequest.requestStatusComments">
                <div class="label">{{ 'StatusComments' | translate: {Default: "Status Comments "} }}: </div>
                {{employeeToilRequest.requestStatusComments}}
            </div>
        </div>
        
        <div class="approval" role="group" aria-label="Approver details">
            <div
                class="approved-by"
                role="group"
                [attr.aria-label]="'Approver' + ((employeeToilRequest?.managers?.length || 0) > 1 ? 's' : '') + ': ' + (showEmployeeTooltip(employeeToilRequest?.managers) || 'Not assigned')"
            >
                <span class="label">{{ 'Approvers' | translate: {Default: "Approvers"} }}:</span>

                <ng-container *ngIf="(employeeToilRequest?.managers?.length || 0) > 1">
                    <mat-icon class="material-icons-outlined employee-list-icon" [matBadge]="employeeToilRequest.managers.length" [matTooltip]="showEmployeeTooltip(employeeToilRequest.managers)" [attr.aria-label]="'Approvers: ' + employeeToilRequest.managers.length + '. ' + showEmployeeTooltip(employeeToilRequest.managers)">
                        account_circle
                    </mat-icon>
                </ng-container>
    
                <ng-container *ngIf="(employeeToilRequest?.managers?.length || 0) == 1">
                    <ng-container *ngFor="let employee of employeeToilRequest.managers">
                        <div class="employee-name">
                            <app-employee-image [profilePhoto]="employee.profilePhoto" [width]="35" [height]="35" [round]="true" *ngIf="!isLoading"></app-employee-image>
    
                            <span class="employee">
                                {{employee.firstName}} {{employee.lastName}}
                            </span>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>

    </div>
    <div class="bottom" role="group" aria-label="Request details">
        <div class="employee-name"><span class="sr-only">{{ 'RequestedBy' | translate: {Default: 'Requested by'} }}: </span>
            <app-employee-image [profilePhoto]="employeeToilRequest.employee.profilePhoto" [width]="35" [height]="35" [round]="true"></app-employee-image>

            <p class="employee">
                {{employeeToilRequest.employee.firstName}} {{employeeToilRequest.employee.lastName}}
            </p>
        </div>

        <p><span class="sr-only">{{ 'ToilType' | translate: {Default: 'TOIL type'} }}: </span>{{employeeToilRequest.toilPolicy?.toilType?.name}} - {{employeeToilRequest.toilPolicy?.name}}</p>

        <p class="dates"><span class="sr-only">{{ 'DateRange' | translate: {Default: 'Date range'} }}: </span>
            {{ moment(employeeToilRequest.startDate).format('ll') }} - {{ moment(employeeToilRequest.endDate).format('ll') }}
            <mat-chip class="green-chip" *ngIf="employeeToilRequest.halfDay === true">{{ 'LeaveRequestHalfDay' | translate: {Default: "Half Day"} }}</mat-chip>
        </p>

        <p *ngIf="employeeToilRequest.startTime && employeeToilRequest.endTime"><span class="sr-only">{{ 'TimeRange' | translate: {Default: 'Time range'} }}: </span>{{ formatTime(employeeToilRequest.startTime) }} - {{ formatTime(employeeToilRequest.endTime) }}</p>
        <p *ngIf="!loadingWorkingHours && workingHours">{{workingHours}} working hours</p>
        <p *ngIf="employeeToilRequest.hours">{{ employeeToilRequest.hours }} hours</p>
        
        <p class="comments"><span class="sr-only">{{ 'Comments' | translate: {Default: 'Comments'} }}: </span><span class="sr-only" *ngIf="!employeeToilRequest.comments">{{ 'NoComments' | translate: {Default: 'No comments'} }}</span>
            {{employeeToilRequest.comments}}
        </p>

        <mat-chip
            [attr.aria-label]="'Request type: ' + (employeeToilRequest.toilClassType?.name || 'Unknown')"
            [ngClass]="{
                'blue-chip': employeeToilRequest.toilClassType?.id === 'AccrueToil',
                'yellow-chip': employeeToilRequest.toilClassType?.id === 'RequestToil'
            }"
        >{{ employeeToilRequest.toilClassType?.name }}</mat-chip>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-stroked-button class="close" appPreventDoubleClick (throttledClick)="close()" type="button" aria-label="Close dialog">{{ 'Close' | translate: {Default: "Close"} }}</button>
</mat-dialog-actions>
